class ProductDuoForm extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.btn = this.querySelector('.jp-product-duo__atc-btn');
    this.originalText = this.btn?.textContent ?? 'Add to Cart';
    this.form?.addEventListener('submit', this.onSubmit.bind(this));
  }

  async onSubmit(e) {
    e.preventDefault();
    if (!this.btn || this.btn.disabled) return;

    this.btn.disabled = true;
    this.btn.textContent = 'Adding…';

    try {
      const variantId = this.form.querySelector('[name="id"]')?.value;
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      });

      if (!response.ok) throw new Error('cart-add-failed');

      this.btn.textContent = 'Added ✓';
      this.refreshCart();

      setTimeout(() => {
        this.btn.textContent = this.originalText;
        this.btn.disabled = false;
      }, 1800);
    } catch {
      this.btn.textContent = this.originalText;
      this.btn.disabled = false;
    }
  }

  refreshCart() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then((r) => r.json())
      .then((cart) => {
        // Update cart bubble count (Dawn-compatible)
        const bubble = document.querySelector('#cart-icon-bubble');
        if (bubble) {
          let countEl = bubble.querySelector('.cart-count-bubble');
          if (!countEl) {
            countEl = document.createElement('div');
            countEl.className = 'cart-count-bubble';
            bubble.appendChild(countEl);
          }
          countEl.innerHTML = `<span aria-hidden="true">${cart.item_count}</span>`;
        }

        // Trigger Dawn's cart notification open if available
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      })
      .catch(() => {});
  }
}

customElements.define('product-duo-form', ProductDuoForm);
